import cx from 'clsx'
import { ElementType } from 'react'
import { Helmet } from 'react-helmet'

import { CategorySub, Hierarchy } from '@karakuri-web/faq-type'

import { toAllBreadcrumbs, toTopBreadcrumbs } from '../utils/breadcrumbs'
import { breadcrumb } from '../utils/ld'

import { BreadcrumbsComponent } from './BreadcrumbsComponent'

interface Props {
  current: Hierarchy
  url: string
  relatedCategories?: readonly CategorySub[]
  onLinkClick?: (link: string, option: unknown) => void
  topTitle?: string
  LinkComponent?: ElementType
}

export function BreadcrumbsList({
  url,
  current,
  onLinkClick,
  relatedCategories,
  LinkComponent,
  topTitle = 'よくあるご質問',
}: Props) {
  const top = toTopBreadcrumbs([], current, topTitle)
  const breadcrumbs = toAllBreadcrumbs(top, relatedCategories || [])

  return (
    <div className={cx('faq-breadcrumb')}>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(breadcrumb(url, top))}</script>
      </Helmet>
      {breadcrumbs.map((hierarchies, index) => (
        <BreadcrumbsComponent
          key={index}
          links={hierarchies}
          onLinkClick={onLinkClick}
          LinkComponent={LinkComponent}
        />
      ))}
    </div>
  )
}
